export default "__VITE_ASSET__DjqHVx0x__"